import { ADMIN_STEP_TASK_IDS } from "@/pages/postloss/get-authorized/administrationSteps";
import { useEstateTaskAnswers } from "@/shared/hooks/useEstateTaskAnswers";

export function useAdminTaskAnswers(estateId: number | undefined) {
  return useEstateTaskAnswers(estateId, ADMIN_STEP_TASK_IDS, "administration");
}
